<div class="fullscreen-gallery-overlay" (click)="closeModal()">
  <div class="gallery-container " (click)="$event.stopPropagation()">
    
    <div class="gallery-header">
      <h3 class="gallery-title">{{ modalTitle }}</h3>
      <div class="gallery-controls">
        <span class="image-count">{{ images.length }} {{ images.length === 1 ? 'image' : 'images' }}</span>
        <button class="close-btn" (click)="closeModal()" aria-label="Close gallery">
          <i class="ti ti-x"></i>
        </button>
      </div>
    </div>

    <div class="gallery-content px-3">
      <app-image-gallery 
        [images]="images"
        [size]="'large'"
        >
      </app-image-gallery>
    </div>

    <div *ngIf="!images || images.length === 0" class="empty-gallery">
      <div class="empty-content">
        <i class="ti ti-photo-off"></i>
        <h4>No Images Available</h4>
        <p>There are no {{ modalTitle.toLowerCase() }} to display at this time.</p>
      </div>
    </div>

  </div>
</div>